function PriceFormat(amount) {
    return Number(amount || 0).toLocaleString('en', { minimumFractionDigits: 2 })
}

export default PriceFormat
